import React, { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { connectReduxDevtools } from 'mst-middlewares';
import { MemoryRouter as Router, Switch, Route } from 'react-router-dom';

import { useStore } from '../../hooks';

import { OfferOptIn } from './views/OfferOptIn';
import { ShareOptions } from './views/ShareOptions';
import { ThankYou } from './views/ThankYou';

export const Main = observer(
	({ campaignId, orderId, email, inviteId, name, phoneNumber, subtotal }) => {
		const store = useStore();

		useEffect(() => {
			connectReduxDevtools(require('remotedev'), store);
		}, []);

		useEffect(() => {
			if (name) store.setName(name);
		}, [name]);

		useEffect(() => {
			store.initCampaign(campaignId);
		}, [store.campaignId, store.publicKey]);

		/**
		 * only track pageview if there is an invite to attribute it to
		 */
		useEffect(() => {
			if (store.inviteId) {
				const conversionType = subtotal && orderId ? 'transaction' : 'pageview';
				// pageviews usually happen before an influencer is created
				// if we have info about the current user, we can pass that in, otherwise they will be guests
				store.trackConversion({
					email: email || 'guest',
					conversionType: store.engagement || conversionType,
					revenue: subtotal,
					inviteId,
					campaignId,
				});
			}
		}, [store.inviteId, email]);

		const { offerText, offerHeading } = store;

		return (
			<Router>
				<Switch>
					<Route path='/' exact>
						<OfferOptIn
							heading={offerHeading}
							description={offerText}
							email={email}
							phoneNumber={phoneNumber}
							subtotal={subtotal}
						/>
					</Route>
					<Route path='/share'>
						<ShareOptions heading={offerHeading} description={offerText} />
					</Route>
					<Route path='/thank-you'>
						<ThankYou />
					</Route>
				</Switch>
			</Router>
		);
	}
);
